import { css } from "styled-components";

export const defaultCardWithText = css`
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: ${({ theme }) => theme.fonts.sizes.s};
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-weight: ${({ theme }) => theme.fonts.weights.bolder};
`;

export const defaultCardWithContent = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const defaultMobileCard = css`
  width: 32px;
  height: 56px;
  border-radius: 4px;
`;

export const defaultCard = css`
  width: 48px;
  height: 80px;

  border-radius: 4px;
`;
